import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import NavLink from 'react-router-dom/es/NavLink'
import className from 'classnames'
import SubMenuItem from './SubMenuItem'

MenuItem.propTypes = {
    menuItem: PropTypes.object.isRequired,
    onClickMenuItem: PropTypes.func.isRequired
}

function MenuItem(props) {
    const {menuItem, onClickMenuItem, history, length, index} = props
    const {href = '', title, fa, label, sub_menu = '', icon = '', target = '', ti} = menuItem

    const [displaySubMenu, setDisplaySubMenu] = useState(false)
    const [activeParent, setActiveParent] = useState(false)

    const _handleClickToggleSubmenu = () => {
        if (sub_menu) setDisplaySubMenu(!displaySubMenu)
    }

    const _toClassName = str => {
        return str.replace(/\s/g, '')
    }

    const _checkActive = () => {
        const hasUrl = !!sub_menu && sub_menu.filter(item => item.href === history.location.pathname)

        if (hasUrl.length > 0 && hasUrl !== false) {
            setActiveParent(true)
        }
    }

    useEffect(() => {
        setActiveParent(false)
        _checkActive()
        // eslint-disable-next-line
    }, [history.location.pathname])

    return (
        <div onClick={onClickMenuItem}
             className={className(`MenuItem ${_toClassName(title)}`, {'SubMenuActive': displaySubMenu}, {'HasChild': !!sub_menu})}>
            {href !== '' ?
                <NavLink to={href || ''} target={target} activeClassName={(href || activeParent) ? "active" : ""}
                         className="nav-link"
                         onClick={_handleClickToggleSubmenu}>
                    {
                        fa && <span className="IconHolder" data-tooltip={title}>
                        <span className="material-icons">{fa}</span>
                    </span>
                    }

                    {
                        ti && <span className="IconHolder" data-tooltip={title}>
                        <i className={ti}/>
                    </span>
                    }

                    {
                        icon && <div className="IconHolder" data-tooltip={title}>
                            <img src={icon} alt="brand" className="BrandIcons"/>
                        </div>
                    }
                    <span className="Title mr-auto">{title}</span>
                    {
                        'label' in menuItem &&
                        <span className="Label badge badge-primary">{label}</span>
                    }
                </NavLink> : <div className="nav-link"
                                  onClick={_handleClickToggleSubmenu}>
                    {
                        fa && <span className="IconHolder" data-tooltip={title}>
                <span className="material-icons">{fa}</span>
                </span>
                    }

                    {
                        ti && <span className="IconHolder" data-tooltip={title}>
                <i className={ti}/>
                </span>
                    }

                    {
                        icon && <div className="IconHolder" data-tooltip={title}>
                            <img src={icon} alt="brand" className="BrandIcons"/>
                        </div>
                    }
                    <span className="Title mr-auto">{title}</span>
                    {
                        'label' in menuItem &&
                        <span className="Label badge badge-primary">{label}</span>
                    }
                </div>}

            {
                !!sub_menu && <span className="ToggleSubMenu ti-Angle-Down cursor-pointer"
                                    onClick={_handleClickToggleSubmenu}/>
            }

            {
                !!sub_menu &&
                <div className={`SubMenu ${(length - 1) === index ? 'Last' : ''}`}>
                    <h6 className="border-bottom mb-0 ml-0 Title">{title}</h6>

                    <ul>
                        {
                            sub_menu.map(item => {
                                return <SubMenuItem key={item.href} item={item}/>
                            })
                        }
                    </ul>
                </div>
            }
        </div>
    )
}

export default MenuItem
